import { cx } from "@emotion/css";
import type * as React from "react";
import * as styles from "./LegacyDataTableStyles";
interface LegacyDataTableRowColumnProps {
    fullWidth?: boolean;
    fullHeight?: boolean;
    className?: string;
    colSpan?: number;
    title?: string;
    children?: React.ReactNode;
}
export function LegacyDataTableRowColumn({ className, fullWidth, fullHeight, children, ...otherProps }: LegacyDataTableRowColumnProps): React.ReactElement {
    const style: React.CSSProperties = {};
    if (fullHeight) {
        style.paddingBottom = 0;
        style.paddingTop = 0;
    }
    if (fullWidth) {
        style.paddingRight = 0;
        style.paddingLeft = 0;
    }
    return (<td {...otherProps} style={style} className={cx(styles.dataTableRowColumn, className)}>
            {children}
        </td>);
}
